import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=a4f968d2&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"
import style0 from "./forget.vue?vue&type=style&index=0&id=a4f968d2&prod&scoped=true&lang=css"
import style1 from "./forget.vue?vue&type=style&index=1&id=a4f968d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f968d2",
  null
  
)

export default component.exports